import { Injectable } from '@angular/core';

import { client } from '@api';
import { activityTemplatesCopy, activityTemplatesDetail } from '@api/sdk.gen';
import type {
  ActivityTemplateDetail,
  AttachmentMode,
  CopyActivityResult,
} from '@api';

export type ActivityTemplateLookupResult =
  | { status: 'found'; detail: ActivityTemplateDetail }
  | { status: 'not-found' }
  | { status: 'error' };

@Injectable({ providedIn: 'root' })
export class ActivityApiService {
  getActivityTemplateById(id: string): Promise<ActivityTemplateDetail> {
    return activityTemplatesDetail({
      path: { id },
      throwOnError: true,
      responseStyle: 'data' as const,
    }) as unknown as Promise<ActivityTemplateDetail>;
  }

  tryGetActivityTemplateById(id: string): Promise<ActivityTemplateLookupResult> {
    return activityTemplatesDetail({
      path: { id },
      throwOnError: false,
      responseStyle: 'fields' as const,
    }).then((result) => {
      if (result.response?.status === 404) {
        return { status: 'not-found' };
      }

      if (result.response?.ok === true && result.data != null) {
        return { status: 'found', detail: result.data };
      }

      return { status: 'error' };
    }) as Promise<ActivityTemplateLookupResult>;
  }

  copy(id: string): Promise<string> {
    return (
      activityTemplatesCopy({
        path: { id },
        throwOnError: true,
        responseStyle: 'data' as const,
      }) as unknown as Promise<CopyActivityResult>
    ).then((result) => result.id);
  }

  getAttachmentContentUrl(attachmentId: string, mode: AttachmentMode): string {
    return client.buildUrl({
      url: '/v1/attachments/{attachmentId}',
      path: { attachmentId },
      query: { mode },
    });
  }
}
